import React from 'react';
import { useTranslation } from 'react-i18next';
import useVersionCheck from '../../../hooks/useVersionCheck';

function NewVersionBanner() {
  const hasNewVersion = useVersionCheck();
  const { t, i18n } = useTranslation();

  if (!hasNewVersion) return null;

  return (
    <div className="fixed w-full bg-yellow-500 text-black p-2 text-sm text-center flex items-center justify-center gap-2 shadow-md" style={{ zIndex: 1000 }}>
      <span>{t('new_version_available')}</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="underline font-semibold"
      >
        {t('refresh_now')}
      </button>
    </div>
  );
}

export default NewVersionBanner;
